import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Drawer, List, message } from 'antd';
import { useSwitch } from '../../pages/SwitchContext';
import { apiGet, parseJsonResponse } from '../../api/apiClient';

export const TextbausteineModal = ({ field, label, category, open, onClose }) => {
  const [fetchedData, setFetchedData] = useState([]);
  const [selectedTextbausteine, setSelectedTextbausteine] = useState([]);
  const { isSwitchOn } = useSwitch();

  useEffect(() => {
    if (!open) return;
    const fetchData = async () => {
      try {
        const response = await apiGet(
          `/textbausteines?filters[Kategorie][$eq]=${category}&sort=rank`
        );
        if (!response.ok) throw new Error('Network response was not ok');
        const dataContainer = await parseJsonResponse(response);
        setFetchedData(
          dataContainer.data
            .filter((e) => e.attributes.Textbaustein_Satz !== null)
            .map((e) => e.attributes)
        );
      } catch (error) {
        console.error(error);
        message.error('Error while fetching profiles!');
      }
    };
    fetchData();
  }, [open, category]);

  const handleCheckboxChange = (satz) => {
    setSelectedTextbausteine((prev) =>
      prev.includes(satz) ? prev.filter((i) => i !== satz) : [...prev, satz]
    );
  };

  const handleInsert = () => {
    const textBox = document.getElementById(field);
    if (textBox) {
      const combined = selectedTextbausteine.join('\n');
      const current = textBox.value || '';
      textBox.value = current ? `${current}\n${combined}` : combined;
      onClose(textBox.value);
    } else {
      onClose();
    }
  };

  return (
    <Drawer
      title="Textbausteine"
      placement="right"
      onClose={onClose}
      open={open}
      width={500}
      className={`${isSwitchOn ? 'text-white' : 'text-black'} ${isSwitchOn ? 'drawerOuter' : ''}`}
    >
      <div className={`${isSwitchOn ? 'bg-black' : 'bg-white'}`}>
        <p>
          <b className={`${isSwitchOn ? 'text-white' : 'text-black'}`}>
            {`Textfeld: ${label}`}
          </b>
        </p>
        {fetchedData.length > 0 ? (
          <List
            bordered
            dataSource={fetchedData}
            renderItem={(item) => (
              <List.Item className={`${isSwitchOn ? 'whiteText' : 'blackText'}`}>
                <Checkbox onChange={() => handleCheckboxChange(item.Textbaustein_Satz)}>
                  <span className={`${isSwitchOn ? 'whiteText' : 'blackText'}`}>
                    {item.Textbaustein_Satz}
                  </span>
                </Checkbox>
              </List.Item>
            )}
          />
        ) : (
          <p>Loading...</p>
        )}
        <br />
        <Button
          type="primary"
          onClick={handleInsert}
          className="bg-[#FF2E3B] mb-[20px] text-[#FFFFFF] ml-[20px] rounded-full buttonHover"
        >
          Markierte Textbausteine einfügen
        </Button>
      </div>
    </Drawer>
  );
};
